import Vue from "vue";

import Modal from "./modal.vue";
Vue.component("modal", Modal);

import Flatpickr from "./flatpickr";
Vue.component("flat-pickr", Flatpickr);

import Select2 from "./select2";
Vue.component("select2", Select2);

import Spinner from "vue-simple-spinner";
Vue.component("vue-simple-spinner", Spinner);

import Loading from "vue-loading-overlay";
Vue.use(Loading);

import vue2Dropzone from "vue2-dropzone";
Vue.component("vue-dropzone", vue2Dropzone);